import { render } from "./SalesPlanningDetails.vue?vue&type=template&id=20b85d85"
import script from "./SalesPlanningDetails.vue?vue&type=script&lang=js"
export * from "./SalesPlanningDetails.vue?vue&type=script&lang=js"

import "./SalesPlanningDetails.vue?vue&type=style&index=0&id=20b85d85&scoper=true&lang=css"

import exportComponent from "/home/clients/74415e597e89acaa30448f5e983fc289/sites/poses.renosolu.fr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__